import { render } from "./AppField.vue?vue&type=template&id=4f1ab89c&scoped=true&lang=pug"
import script from "./AppField.vue?vue&type=script&setup=true&lang=js"
export * from "./AppField.vue?vue&type=script&setup=true&lang=js"

import "./AppField.vue?vue&type=style&index=0&id=4f1ab89c&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1ab89c"]])

export default __exports__